import React, { Component } from 'react'
import { Row, Col, Icon } from 'antd'
import { randomNum } from 'helper'

const palette = ['#51556d', '#51616d', '#76716c', '#876f6f', '#6b576e']

class ExamCard extends Component {
  state = {
    transit: false,
    markSelected: null,
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState(
        {
          transit: true,
          markSelected: null,
        },
        () => {
          setTimeout(() => {
            this.setState({
              transit: false,
            })
          }, 50)
        },
      )
    }
  }

  markSelected = index => {
    this.setState({
      markSelected: index,
    })
  }

  render() {
    const bgColor = palette[randomNum(0, 4)]
    const { transit, markSelected } = this.state
    const { current, data, handleOptionClick } = this.props

    return (
      <Row>
        <Col style={{ position: 'relative', marginTop: 50, height: 350, overflow: 'hidden' }}>
          <div
            style={{
              width: 300,
              backgroundColor: transit ? 'transparent' : bgColor,
              transition: transit ? 'none' : 'all .5s cubic-bezier(0.645, 0.045, 0.355, 1.000)',
              margin: '0 auto',
              borderRadius: 3,
              height: 240,
              padding: 20,
            }}
          >
            <div
              style={{
                float: 'left',
                height: '100%',
                width: 40,
                fontSize: 26,
                fontWeight: 700,
                opacity: 0.3,
              }}
            >
              <span style={{ transition: transit ? 'none' : 'all .3s', marginLeft: transit ? -10 : 0 }}>
                {current + 1}
              </span>
            </div>
            <div
              style={{
                height: '100%',
                fontSize: 14,
                padding: 12,
                lineHeight: '25px',
                marginTop: transit ? 20 : 0,
                opacity: transit ? 0 : 0.9,
                transition: transit ? 'none' : 'all .3s',
              }}
            >
              {data.question}
            </div>
          </div>

          <div
            style={{
              position: 'absolute',
              top: 140,
              width: '100%',
              textAlign: 'center',
            }}
          >
            <div style={{ position: 'relative', width: '70%', height: '100%', margin: '0 auto' }}>
              <div
                style={{
                  display: 'inline-block',
                  position: 'absolute',
                  transition: transit ? 'none' : 'all .5s cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                  left: transit ? -200 : 0,
                  opacity: transit ? 0 : 1,
                }}
              >
                <div style={{ width: '100%', height: '100%', backgroundColor: '#414555' }}>
                  <Icon
                    style={{
                      position: 'absolute',
                      top: '40%',
                      left: '40%',
                      color: '#c68a80',
                      fontSize: 30,
                      opacity: markSelected === 0 ? 1 : 0,
                    }}
                    type='check'
                  />
                  <img
                    style={{ width: 122, opacity: markSelected === 0 ? 0.1 : 1, transition: 'all .3s' }}
                    src={transit ? null : data.options[0].image_url}
                    alt='option1'
                    onClick={() => {
                      handleOptionClick(data.options[0])
                      this.markSelected(0)
                    }}
                  />
                </div>
              </div>

              <div
                style={{
                  display: 'inline-block',
                  position: 'absolute',
                  transition: transit ? 'none' : 'all .5s cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                  right: transit ? -200 : 0,
                  opacity: transit ? 0 : 1,
                }}
              >
                <div style={{ width: '100%', height: '100%', backgroundColor: '#414555' }}>
                  <Icon
                    style={{
                      position: 'absolute',
                      top: '40%',
                      left: '40%',
                      color: '#c68a80',
                      fontSize: 30,
                      opacity: markSelected === 1 ? 1 : 0,
                    }}
                    type='check'
                  />
                  <img
                    style={{ width: 122, opacity: markSelected === 1 ? 0.1 : 1, transition: 'all .3s' }}
                    src={transit ? null : data.options[1].image_url}
                    alt='option2'
                    onClick={() => {
                      handleOptionClick(data.options[1])
                      this.markSelected(1)
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    )
  }
}

export default ExamCard
